export const TASK_TYPE_ITEMS = [
  {
    icon: {
      id: 1,
      name: 'chimney_sweep.svg',
    },
    id: 1,
    name: 'Standard',
  },
  {
    icon: {
      id: 2,
      name: 'posting_2.svg',
    },
    id: 2,
    name: 'Flight',
  },
  { icon: { id: 3, name: 'call_2.svg' }, id: 3, name: 'Call' },
]
